import { Trans, useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { paths } from '@mc/paths'

import CTA from 'components/CTA'

import { checkoutCtaTrackProps } from './constants'

const FooterContentMobile = () => {
  const { t } = useTranslation('@mc/next')
  const { guestPass } = useStaticData()

  return (
    <div className='row'>
      <div className='col-8'>
        <h2 className='mc-text-h2 mc-text--brand mc-text--uppercase mc-mb-2'>
          <Trans
            ns='@mc/next'
            i18nKey='guestPass.footer.title'
            values={{ name: guestPass.advocate.name }}
          >
            <span className='mc-text--1-line-max' />
            <br />
          </Trans>
        </h2>
        <h6 className='mc-text-h8'>{t('guestPass.footer.description')}</h6>
      </div>
      <div className='col-4 d-flex justify-content-end'>
        <div>
          <CTA href={paths.checkout} trackProps={checkoutCtaTrackProps}>
            {t('guestPass.footer.cta.mobile')}
          </CTA>
        </div>
      </div>
    </div>
  )
}

export default FooterContentMobile
